import script from "./sqmComplaintRectification.vue?vue&type=script&setup=true&lang=js"
export * from "./sqmComplaintRectification.vue?vue&type=script&setup=true&lang=js"

import "./sqmComplaintRectification.vue?vue&type=style&index=0&id=121cb3e6&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121cb3e6"]])

export default __exports__